import { stringPadStart } from '@dazn/peng-html5-tools-utils';
/**
 * Returns a message code based on the package namespace, feature number and message id.
 *
 * @example
 * ```ts
 * formatMessageCode('COR', 1, 5);
 * // => 'COR-01005'
 * ```
 */
var formatMessageCode = function (packageNamespace, featureNumber, id) {
    var paddedFeatureNumber = stringPadStart(featureNumber.toString(), 2, '0');
    var paddedMessageId = stringPadStart(id.toString(), 3, '0');
    return "".concat(packageNamespace, "-").concat(paddedFeatureNumber).concat(paddedMessageId);
};
export { formatMessageCode };
//# sourceMappingURL=formatMessageCode.js.map